<template>
  <Modal v-model="modal" :title="info.Id?$t('title.w52'):$t('title.w53')" :mask-closable="false">
    <Form label-position="top" :model="form" ref="form" :rules="formRule">
      <FormItem :label="$t('label.w160')" prop="pwd">
        <Select v-model="form.operatorId">
          <Option v-for="item in regList" :value="item.Id" :key="item.Id">{{ item.Name }}</Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('label.w195')" prop="accountId">
        <Input :placeholder="needmsg?$t('pl.p13')+needmsg.AccountTip:''" v-model="form.accountId"/>
      </FormItem>
      <FormItem :label="$t('label.w162')" prop="verifyInfo">
        <Input :placeholder="needmsg?$t('pl.p13')+needmsg.VerifyInfoTip:''" v-model="form.verifyInfo"/>
      </FormItem>
      <FormItem :label="codeType==2?$t('label.w35'):$t('label.w36')" prop="code" class="formitem">
        <a href="javascript:;" class="text-primary" v-if="codeType==2" @click="codeType=1">{{$t('nav.w59')}}</a>
        <a href="javascript:;" class="text-primary" v-if="codeType==1" @click="codeType=2">{{$t('nav.w60')}}</a>
        <Row type="flex" :gutter="10">
          <Col span="18">
            <Input :placeholder="$t('pl.p8')" v-model="form.code"/>
          </Col>
          <Col span="6">
            <Codebtn type="SendOperatorCode" :to="codeType"/>
          </Col>
        </Row>
      </FormItem>
    </Form>
    <template slot="footer">
      <Button type="primary" :loading="loading" :disabled="btnDisable" @click="submit">{{$t('btn.b5')}}</Button>
    </template>
  </Modal>
</template>
<script>
import Codebtn from "@/components/sendCodeButton";
import formRule from "@/libs/formRule";
import Rsa from "@/libs/Rsa";
export default {
  components: { Codebtn },
  data() {
    return {
      modal: false,
      info: {},
      loading: false,
      regList: [],
      codeType: 2, // 1邮箱 2手机
      form: {
        operatorId: "",
        accountId: "",
        verifyInfo: "",
        code: ""
      },
      formRule: {
        accountId: formRule.empty(this.$t('msg.m67')),
        verifyInfo: formRule.empty(this.$t('msg.m68')),
        code: formRule.code
      }
    };
  },
  methods: {
    async submit() {
      let valid = await this.$refs.form.validate();
      if (!valid) return;

      let id = this.info.Id;
      this.loading = true;

      let res = await this.$axios.post("/Member/RZJPledge/EditUserOperator", {
        id,
        codeType: this.codeType,
        ...this.form
      });

      this.loading = false;
      res.throw();
      if (!res.err) {
        this.modal = false;
        this.$emit("done");
      }
    },
    reset() {
      this.form.operatorId = "";
      this.$refs.form.resetFields();
    },
    async getRegList() {
      this.regList = [];
      let res = await this.$axios.get("/Member/RZJPledge/OperatorsSelectList");
      if (!res.err) this.regList = res;
      if (this.info.Id) {
        this.regList.unshift({
          Id: this.info.OperatorId,
          Name: this.info.OperatorName,
          AccountTip:this.info.AccountTip,
          VerifyInfoTip:this.info.VerifyInfoTip,
        });
        this.form = {
          operatorId: this.info.OperatorId,
          accountId: this.info.AccountName,
          verifyInfo: this.info.VerifyInfo,
          code: ""
        };
      }
    }
  },
  mounted() {},
  computed: {
    btnDisable() {
      return (
        this.form.operatorId == "" ||
        this.form.accountId == "" ||
        this.form.verifyInfo == "" ||
        this.form.code == ""
      );
    },
    needmsg() {
      return this.regList.filter(k => {
        return k.Id.match(this.form.operatorId);
      })[0];
    }
  },
  watch: {
    modal(v) {
      if (!v) this.reset();
      else {
        this.getRegList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.formitem {
  position: relative;
  a {
    position: absolute;
    right: 0;
    top: -18px;
    line-height: 1;
  }
}
</style>
